import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { QuestionDisplay } from './components/QuestionDisplay';
import { AdminPanel } from './components/AdminPanel';
import { Login } from './components/Login';
import { authService } from './services/auth';
import { supabase } from './lib/supabase';
import { ErrorBoundary } from './components/ErrorBoundary';

function PageTitle() {
  const location = useLocation();

  useEffect(() => {
    const baseTitle = 'QuizFlow';
    let pageTitle = baseTitle;

    switch (location.pathname) {
      case '/admin':
        pageTitle = `${baseTitle} - Administration`;
        break;
      case '/login':
        pageTitle = `${baseTitle} - Connexion`;
        break;
      default:
        pageTitle = baseTitle;
    }

    document.title = pageTitle;
  }, [location]);

  return null;
}

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      setIsAuthenticated(!!session);
    });

    // Vérifier l'état initial
    supabase.auth.getSession().then(({ data: { session } }) => {
      setIsAuthenticated(!!session);
    });

    return () => subscription.unsubscribe();
  }, []);

  if (isAuthenticated === null) {
    return <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600"></div>
    </div>;
  }

  return isAuthenticated ? <>{children}</> : <Navigate to="/login" />;
}

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <PageTitle />
        <Routes>
          <Route path="/" element={<QuestionDisplay />} />
          <Route
            path="/admin"
            element={
              <PrivateRoute>
                <AdminPanel />
              </PrivateRoute>
            }
          />
          <Route path="/login" element={<Login />} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;